<template>
  <div>Report filter component</div>
</template>

<script>
export default {};
</script>

<style>
</style>
